export const RESET_LAYERS = 'LAYERS/RESET_LAYERS_IN_COMPARE_GROUP';
export const ADD_LAYER = 'LAYERS/ADD_LAYER_TO_COMPARE_GROUP';
export const REORDER_LAYERS = 'LAYERS/REORDER_LAYERS';
export const REORDER_OVERLAY_GROUPS = 'LAYERS/REORDER_OVERLAY_GROUPS';
export const TOGGLE_OVERLAY_GROUPS = 'LAYERS/TOGGLE_OVERLAY_GROUPS';
export const INIT_SECOND_LAYER_GROUP = 'LAYERS/INIT_SECOND_COMPARE_GROUP';
export const TOGGLE_ACTIVE_STATE = 'LAYERS/TOGGLE_ACTIVE_LAYER_STATE';
export const TOGGLE_LAYER_VISIBILITY = 'LAYERS/TOGGLE_LAYER_VISIBILITY';
export const TOGGLE_OVERLAY_GROUP_VISIBILITY = 'LAYERS/TOGGLE_OVERLAY_GROUP_VISIBILITY';
export const TOGGLE_COLLAPSE_OVERLAY_GROUP = 'LAYERS/TOGGLE_COLLAPSE_OVERLAY_GROUP';
export const REMOVE_LAYER = 'LAYERS/REMOVE_LAYER';
export const REMOVE_GROUP = 'LAYERS/REMOVE_OVERLAY_GROUP';
export const UPDATE_OPACITY = 'LAYERS/UPDATE_OPACITY';
export const ADD_LAYERS_FOR_EVENT = 'LAYERS/ADD_LAYERS_FOR_EVENT';
